export const DEFAULT_REFRESH_INTERVAL = 1000 / 5;
export const DAYS_HOURS_MINUTES_SECOND_FORMAT = "dd'd':hh'h':mm'm':ss's'";
